"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCallbackUrlQueryParamFromQuery = void 0;
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const crossLogin_constants_1 = require("./crossLogin.constants");
const getCallbackUrlQueryParamFromQuery = (query) => {
    if (!query) {
        return undefined;
    }
    const urlWithToken = query[crossLogin_constants_1.CROSS_LOGIN_URL_WITH_TOKEN_PARAM_NAME] ||
        query[(0, camelCase_1.default)(crossLogin_constants_1.CROSS_LOGIN_URL_WITH_TOKEN_PARAM_NAME)];
    const url = query[crossLogin_constants_1.CROSS_LOGIN_URL_PARAM_NAME] ||
        query[(0, camelCase_1.default)(crossLogin_constants_1.CROSS_LOGIN_URL_PARAM_NAME)];
    if (urlWithToken) {
        return {
            name: crossLogin_constants_1.CROSS_LOGIN_URL_WITH_TOKEN_PARAM_NAME,
            value: urlWithToken,
        };
    }
    else if (url) {
        return {
            name: crossLogin_constants_1.CROSS_LOGIN_URL_PARAM_NAME,
            value: url,
        };
    }
    return undefined;
};
exports.getCallbackUrlQueryParamFromQuery = getCallbackUrlQueryParamFromQuery;
//# sourceMappingURL=getCallbackUrlQueryParamFromQuery.js.map